export const convertDateFormat = (dateStr?: string | null) => {
  if (!dateStr) return ""; // Handle null or undefined input
  return dateStr.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3");
};
